// @ts-check
import React from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector, useDispatch } from "react-redux";
import { SET_RENDERED_SOLUTION } from '../../redux/actions/actionTypes';

const useStyles = makeStyles((theme) => ({
  solutionTile: {
    height: '120px',
    width: '13vw',
    border: '1px solid #5B5B5B',
    backgroundColor: '#CACACA',
    margin: '3px 3px',
    cursor: 'pointer',
    borderRadius: "5px",
    padding: "3px"

  },
  solutionTileDarker: {
    height: '120px',
    width: '13vw',
    border: '1px solid #5B5B5B',
    backgroundColor: '#8A8A8A',
    margin: '3px 3px',
    cursor: 'pointer',
    borderRadius: "5px",
    padding: "3px",
    color: 'white',

  },
  tileTitle: {
    margin: '2px auto auto 2px'
  },
  titleItem: {
    margin: '4px 0px 2px 2px',
    fontSize: '0.6em'
  }
}));

function SolutionTile(props) {
  const numOfUnits = function settable2() {
    let t2 = 0;
    // eslint-disable-next-line
    for (const [key, value] of Object.entries(props.solution?.reports?.units_report?.table_2)) {
      t2 = t2 + value.number_of_units;
    }
    return t2
  }

  const shapeConvert = {
    'H_shaped': 'Single-family',
    'D_shaped': 'Semi-detached',
    'T_shaped': 'Terrace',
    'I_shaped': 'I Shaped',
    'L_shaped': 'L Shaped',
    'O_shaped': 'O Shaped',

  }

  const styles = useStyles();
  const dispatch = useDispatch()

  const solutionName = props.solution.solution_name
  const selectedName = props.selectedName
  const bType = shapeConvert[props.solution.building_type]

  const units = props.solution?.reports.units_report.reported_units
  const currency = props.solution?.reports.economic_report.currency

  const operationalCarbonBreakdown = () => {
    return props.solution.reports.environmental_report.lca_dictionary.breakdown.embodied_carbon_tonco2_life +
        props.solution.reports.environmental_report.lca_dictionary.breakdown.operational_carbon_tonco2_life
    
  }


  return (
    <Box display='flex' flexDirection='column'
      className={solutionName === selectedName ? styles.solutionTileDarker : styles.solutionTile}
      onClick={(event) => {
        dispatch({
          type: SET_RENDERED_SOLUTION,
          payload: props.index
        })
      }}
    >
      <span className={styles.tileTitle}>{'Option ' + (props.index + 1).toString()}</span>
      <Box display='grid' gridTemplateColumns='60% 40%' >
        <span className={styles.titleItem}>Type:</span>
        <span className={styles.titleItem}>{bType}</span>
        <span className={styles.titleItem}>Built area ({units}²):</span>
        <span className={styles.titleItem}>{props.solution?.reports.units_report?.table_1.total_built_area.toLocaleString()}</span>
        <span className={styles.titleItem}>Units:</span>
        <span className={styles.titleItem}>{numOfUnits().toLocaleString()}</span>
        <span className={styles.titleItem}>Annual emissions (tonCO<sub>2e</sub>/life):</span>
        <span className={styles.titleItem}>{operationalCarbonBreakdown().toLocaleString()}</span>
      </Box>
    </Box>
  )
}

export default SolutionTile